/* Cromo — JS del tema. Sin dependencias; se carga con defer. */
(() => {
  const $ = (sel, root = document) => root.querySelector(sel);
  const $$ = (sel, root = document) => [...root.querySelectorAll(sel)];
  const reduceMotion = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const finePointer = matchMedia('(hover: hover) and (pointer: fine)').matches;
  const routes = (window.theme && window.theme.routes) || {};
  const strings = (window.theme && window.theme.strings) || {};

  /* ---------- Cuenta atrás (fecha fija, se oculta al acabar) ---------- */
  class CountdownTimer extends HTMLElement {
    connectedCallback() {
      this.end = Date.parse(this.dataset.end);
      if (Number.isNaN(this.end) || this.end <= Date.now()) return;
      this.hidden = false;
      this.parts = { d: $('[data-d]', this), h: $('[data-h]', this), m: $('[data-m]', this), s: $('[data-s]', this) };
      this.tick();
      this.timer = setInterval(() => this.tick(), 1000);
    }
    disconnectedCallback() { clearInterval(this.timer); }
    tick() {
      const left = Math.max(0, this.end - Date.now());
      if (!left) { clearInterval(this.timer); this.hidden = true; return; }
      const s = Math.floor(left / 1000);
      const pad = (n) => String(n).padStart(2, '0');
      this.parts.d.textContent = pad(Math.floor(s / 86400));
      this.parts.h.textContent = pad(Math.floor((s % 86400) / 3600));
      this.parts.m.textContent = pad(Math.floor((s % 3600) / 60));
      this.parts.s.textContent = pad(s % 60);
    }
  }
  customElements.define('countdown-timer', CountdownTimer);

  /* ---------- Cabecera ---------- */
  const header = $('[data-header]');
  if (header) {
    const sentinel = document.createElement('div');
    sentinel.style.cssText = 'position:absolute;top:0;height:1px;width:1px';
    document.body.prepend(sentinel);
    new IntersectionObserver(([e]) => header.classList.toggle('is-scrolled', !e.isIntersecting)).observe(sentinel);
  }
  const menu = $('[data-menu-drawer]');
  if (menu) {
    document.addEventListener('keydown', (e) => { if (e.key === 'Escape' && menu.open) { menu.open = false; $('summary', menu).focus(); } });
    menu.addEventListener('click', (e) => { if (e.target.closest('a')) menu.open = false; });
  }

  /* ---------- Aparición al hacer scroll ---------- */
  const revealIO = 'IntersectionObserver' in window && document.body.classList.contains('reveal-on')
    ? new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) { e.target.classList.add('is-in'); revealIO.unobserve(e.target); }
        });
      }, { rootMargin: '0px 0px -8% 0px' })
    : null;
  const watchReveal = (root = document) => $$('.reveal:not(.is-in)', root).forEach((el) => (revealIO ? revealIO.observe(el) : el.classList.add('is-in')));
  watchReveal();

  /* ---------- Inclinación 3D de tarjetas ---------- */
  if (finePointer && !reduceMotion) {
    let active = null;
    let frame = 0;
    let point = null;
    const MAX = 9;
    const apply = () => {
      frame = 0;
      if (!active || !point) return;
      const r = active.getBoundingClientRect();
      const px = (point.x - r.left) / r.width;
      const py = (point.y - r.top) / r.height;
      active.style.setProperty('--ry', `${(px - 0.5) * MAX * 2}deg`);
      active.style.setProperty('--rx', `${(0.5 - py) * MAX * 2}deg`);
      active.style.setProperty('--mx', `${px * 100}%`);
      active.style.setProperty('--my', `${py * 100}%`);
    };
    const reset = (el) => {
      el.classList.remove('is-tilting');
      el.style.setProperty('--rx', '0deg');
      el.style.setProperty('--ry', '0deg');
    };
    document.addEventListener('pointerover', (e) => {
      const el = e.target.closest('.js-tilt');
      if (el === active) return;
      if (active) reset(active);
      active = el;
      if (active) active.classList.add('is-tilting');
    });
    document.addEventListener('pointermove', (e) => {
      if (!active) return;
      point = { x: e.clientX, y: e.clientY };
      if (!frame) frame = requestAnimationFrame(apply);
    }, { passive: true });
    document.addEventListener('pointerout', (e) => {
      if (active && !active.contains(e.relatedTarget)) { reset(active); active = null; }
    });
  }

  /* ---------- Escena 3D del hero ---------- */
  $$('[data-hero]').forEach((hero) => {
    const stage = $('[data-stage]', hero);
    const tilt = $('[data-stage-tilt]', hero);
    if (!stage || !tilt) return;
    new IntersectionObserver(([e]) => stage.classList.toggle('is-paused', !e.isIntersecting)).observe(stage);
    if (!finePointer || reduceMotion) return;
    let frame = 0;
    let target = { x: 0, y: 0 };
    hero.addEventListener('pointermove', (e) => {
      const r = hero.getBoundingClientRect();
      target = { x: ((e.clientX - r.left) / r.width - 0.5) * 22, y: ((e.clientY - r.top) / r.height - 0.5) * -14 };
      if (!frame) frame = requestAnimationFrame(() => {
        frame = 0;
        tilt.style.setProperty('--tx', target.x.toFixed(2));
        tilt.style.setProperty('--ty', target.y.toFixed(2));
      });
    }, { passive: true });
    hero.addEventListener('pointerleave', () => {
      tilt.style.setProperty('--tx', 0);
      tilt.style.setProperty('--ty', 0);
    });
  });

  /* ---------- Carrito (AJAX + Section Rendering API) ---------- */
  const drawerSection = 'cart-drawer';
  const getDrawer = () => $('[data-cart-drawer]');
  let lastFocus = null;

  const setCount = (count) => {
    $$('[data-cart-count]').forEach((el) => { el.textContent = count; el.hidden = !count; });
    const btn = $('.cart-btn');
    if (btn) { btn.classList.remove('is-bump'); void btn.offsetWidth; btn.classList.add('is-bump'); }
  };

  const renderDrawer = (html) => {
    const current = getDrawer();
    if (!current || !html) return;
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const fresh = $('[data-cart-drawer]', doc);
    if (!fresh) return;
    $('.drawer__panel', current).replaceWith($('.drawer__panel', fresh));
    current.dataset.count = fresh.dataset.count;
    setCount(Number(fresh.dataset.count));
  };

  const openDrawer = () => {
    const drawer = getDrawer();
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.hidden = false;
    requestAnimationFrame(() => {
      drawer.classList.add('is-open');
      $('.drawer__panel', drawer).focus({ preventScroll: true });
    });
    document.documentElement.style.overflow = 'hidden';
    return true;
  };

  const closeDrawer = () => {
    const drawer = getDrawer();
    if (!drawer || drawer.hidden) return;
    drawer.classList.remove('is-open');
    document.documentElement.style.overflow = '';
    setTimeout(() => { drawer.hidden = true; }, reduceMotion ? 0 : 400);
    if (lastFocus) lastFocus.focus({ preventScroll: true });
  };

  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-cart-open]') && window.theme.cartType === 'drawer' && openDrawer()) e.preventDefault();
    if (e.target.closest('[data-cart-close]')) closeDrawer();
  });
  document.addEventListener('keydown', (e) => { if (e.key === 'Escape') closeDrawer(); });

  const postJSON = async (url, body) => {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    });
    const data = await res.json();
    if (!res.ok) throw new Error(data.description || data.message || strings.error);
    return data;
  };

  const cartPage = () => $('[data-cart-page]');
  const sectionsFor = () => [drawerSection, cartPage() && cartPage().dataset.section].filter(Boolean);

  const renderCartPage = (sections) => {
    const page = cartPage();
    if (!page || !sections[page.dataset.section]) return;
    const doc = new DOMParser().parseFromString(sections[page.dataset.section], 'text/html');
    const fresh = $('[data-cart-page]', doc);
    if (fresh) page.replaceWith(fresh);
  };

  // Añadir al carrito
  document.addEventListener('submit', async (e) => {
    const form = e.target.closest('[data-product-form]');
    if (!form || e.submitter && e.submitter.name === 'checkout') return;
    e.preventDefault();
    const btn = e.submitter || $('[type="submit"]', form);
    const status = $('[data-form-status]', form);
    btn.classList.add('is-loading');
    btn.setAttribute('aria-busy', 'true');
    if (status) { status.textContent = ''; status.classList.remove('is-error'); }
    try {
      const fd = new FormData(form);
      const body = {
        items: [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity') || 1) }],
        sections: sectionsFor(),
        sections_url: location.pathname,
      };
      const data = await postJSON(`${routes.cartAdd}.js`, body);
      if (window.theme.cartType === 'drawer' && data.sections) {
        renderDrawer(data.sections[drawerSection]);
        openDrawer();
      } else {
        location.href = routes.cart;
      }
      if (status) status.textContent = strings.added;
    } catch (err) {
      if (status) { status.textContent = err.message; status.classList.add('is-error'); }
    } finally {
      btn.classList.remove('is-loading');
      btn.removeAttribute('aria-busy');
    }
  });

  // Cambiar cantidades / quitar líneas
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('[data-line-qty]');
    if (!btn) return;
    const line = btn.closest('[data-line]');
    const scope = btn.closest('[data-cart-drawer], [data-cart-page]');
    scope.classList.add('is-updating');
    try {
      const data = await postJSON(`${routes.cartChange}.js`, {
        line: Number(line.dataset.line),
        quantity: Number(btn.dataset.lineQty),
        sections: sectionsFor(),
        sections_url: location.pathname,
      });
      renderDrawer(data.sections[drawerSection]);
      renderCartPage(data.sections);
      setCount(data.item_count);
    } catch (err) {
      alert(err.message);
    } finally {
      scope.classList.remove('is-updating');
    }
  });

  /* ---------- Ficha de producto ---------- */
  $$('[data-product]').forEach((product) => {
    const form = $('[data-product-form]', product);
    const variantsEl = $('[data-variants]', product);
    const addBtn = $('[data-add-button]', product);

    // Selector de variantes
    if (form && variantsEl) {
      const variants = JSON.parse(variantsEl.textContent);
      const idInput = $('[data-variant-id]', form);
      form.addEventListener('change', async (e) => {
        if (!e.target.matches('[data-option]')) return;
        const selected = $$('[data-option]:checked', form).map((i) => i.value);
        const variant = variants.find((v) => v.options.every((o, i) => o === selected[i]));
        if (!variant) {
          addBtn.disabled = true;
          $('[data-add-label]', addBtn).textContent = strings.soldOut;
          return;
        }
        idInput.value = variant.id;
        addBtn.disabled = !variant.available;
        const url = `${location.pathname}?variant=${variant.id}`;
        history.replaceState(null, '', url);
        if (variant.featured_media) {
          const slide = $(`[data-media-id="${variant.featured_media.id}"]`, product);
          if (slide) slide.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
        }
        // Precio y estado del botón vienen renderizados del servidor
        const html = await fetch(`${url}&section_id=${product.dataset.section}`).then((r) => r.text());
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const freshPrice = $('[data-product-price]', doc);
        const freshLabel = $('[data-add-label]', doc);
        if (freshPrice) $('[data-product-price]', product).replaceWith(freshPrice);
        if (freshLabel) $('[data-add-label]', addBtn).textContent = freshLabel.textContent;
        const stickyPrice = $('[data-sticky-buy] [data-price]', product);
        const freshSticky = $('[data-sticky-buy] [data-price]', doc);
        if (stickyPrice && freshSticky) stickyPrice.replaceWith(freshSticky);
      });
    }

    // Cantidad
    $$('[data-qty]', product).forEach((qty) => {
      const input = $('input', qty);
      qty.addEventListener('click', (e) => {
        const step = e.target.closest('[data-qty-step]');
        if (!step) return;
        input.value = Math.max(1, Number(input.value || 1) + Number(step.dataset.qtyStep));
      });
    });

    // Galería: miniaturas sincronizadas con el carrusel
    const track = $('[data-gallery-track]', product);
    const thumbs = $$('[data-thumb]', product);
    if (track && thumbs.length) {
      thumbs.forEach((t) => t.addEventListener('click', () => {
        const slide = $(`[data-media-id="${t.dataset.thumb}"]`, track);
        track.scrollTo({ left: slide.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      }));
      const io = new IntersectionObserver((entries) => {
        entries.forEach((en) => {
          if (!en.isIntersecting) return;
          thumbs.forEach((t) => t.classList.toggle('is-active', t.dataset.thumb === en.target.dataset.mediaId));
        });
      }, { root: track, threshold: 0.6 });
      $$('[data-media-id]', track).forEach((s) => io.observe(s));
    }

    // Carrusel de opiniones (una a la vez, flechas y puntos)
    $$('[data-mini-reviews]', product).forEach((box) => {
      const track = $('[data-mini-track]', box);
      const slides = $$('[data-mini-slide]', box);
      if (slides.length < 2) return;
      const dotsWrap = $('[data-mini-dots]', box);
      const dots = slides.map((_, i) => {
        const dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'mini-reviews__dot';
        dot.setAttribute('aria-label', `${i + 1} / ${slides.length}`);
        dot.addEventListener('click', () => go(i));
        dotsWrap.append(dot);
        return dot;
      });
      let current = 0;
      const go = (i) => {
        current = (i + slides.length) % slides.length;
        mark();
        track.scrollTo({ left: slides[current].offsetLeft - track.offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      const mark = () => dots.forEach((d, i) => d.setAttribute('aria-current', String(i === current)));
      $('[data-mini-prev]', box).addEventListener('click', () => go(current - 1));
      $('[data-mini-next]', box).addEventListener('click', () => go(current + 1));
      track.addEventListener('scroll', () => {
        const i = Math.round(track.scrollLeft / track.clientWidth);
        if (i !== current) { current = i; mark(); }
      }, { passive: true });
      mark();
      $('[data-mini-controls]', box).hidden = false;
    });

    // Barra fija de compra en móvil
    const sticky = $('[data-sticky-buy]', product);
    if (sticky && addBtn) {
      const stickyBtn = $('[data-sticky-add]', sticky);
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show);
        sticky.setAttribute('aria-hidden', String(!show));
        stickyBtn.tabIndex = show ? 0 : -1;
      }).observe(addBtn);
      stickyBtn.addEventListener('click', () => form.requestSubmit(addBtn));
    }
  });

  /* ---------- Recomendaciones (carga diferida) ---------- */
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const io = new IntersectionObserver(async ([e]) => {
        if (!e.isIntersecting) return;
        io.disconnect();
        try {
          const html = await fetch(this.dataset.url).then((r) => r.text());
          const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('product-recommendations');
          if (fresh && fresh.innerHTML.trim()) { this.innerHTML = fresh.innerHTML; watchReveal(this); }
        } catch (_) { /* sin recomendaciones */ }
      }, { rootMargin: '600px 0px' });
      io.observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  /* ---------- Editor de temas: reenganchar al recargar secciones ---------- */
  document.addEventListener('shopify:section:load', (e) => watchReveal(e.target));
})();
